// Components==============
import { MyPortfolioContext } from 'pages/Portfolio/MyPortfolios/MyPortfolio';
import React, { useContext } from 'react';
import './LayoutButtons.module.scss';
// =========================

export default function LayoutButtons() {
  const { handleChangeLayout, currentPortfolio } = useContext(
    MyPortfolioContext
  );

  const layoutButtons: GridOptions[] = ['grid1', 'grid2', 'grid3', 'grid4'];
  return (
    <>
      <div styleName="grids">
        {layoutButtons?.map((item, i) => (
          <div
            key={i}
            styleName={`layout ${
              currentPortfolio?.layout === `${item}` ? 'active' : ''
            }`}
            onClick={() => {
              handleChangeLayout(item);
            }}
          >
            <img src={`/images/grids-portfolio/${item}.svg`} alt={item} />
          </div>
        ))}
      </div>
    </>
  );
}
